import { render, staticRenderFns } from "./CameraFeed.vue?vue&type=template&id=4f78e368&"
import script from "./CameraFeed.vue?vue&type=script&lang=js&"
export * from "./CameraFeed.vue?vue&type=script&lang=js&"
import style0 from "./CameraFeed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports